/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { WeightChangeCategoryDto } from './weightChangeCategoryDto';

export interface WeightReportDto {
  id?: string;
  workOrderId?: string;
  projectId?: string;
  performedBy?: string;
  company?: string;
  discipline?: string;
  mainCategory?: WeightReportDto.MainCategoryEnum;
  areaTagSystem?: string;
  quantityMetres?: string;
  hoursSpent?: number;
  installedWeight?: string;
  removedWeight?: string;
  netWeightChange?: string;
  changeFollowUpRequired?: boolean;
  description?: string;
  comment?: string;
  recipientEmail?: string;
  emailSentAt?: string;
  createdAt?: string;
  selectedCategories?: Array<WeightChangeCategoryDto>;
}
export namespace WeightReportDto {
  export const MainCategoryEnum = {
    AdditionalWork: 'ADDITIONAL_WORK',
    WeightChange: 'WEIGHT_CHANGE',
    Other: 'OTHER',
  } as const;
  export type MainCategoryEnum = (typeof MainCategoryEnum)[keyof typeof MainCategoryEnum];
}
